module.exports = __webpack_public_path__ + "static/media/buidl-mobile.e710c630.jpeg";